import { Component, OnDestroy, OnInit } from '@angular/core';

/**
 * 業務閉塞画面
 * @example
 * 業務閉塞中に表示する画面。
 * 
 *【呼び出し元】
 * this.router.navigate(['/sgkz006d/']);
 * @export
 * @class Sgkz006dComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-sgkz006d',
  templateUrl: './sgkz006d.component.html',
  styleUrls: ['./sgkz006d.component.scss']
})
export class Sgkz006dComponent implements OnInit, OnDestroy {

  /**
  * コンストラクタ
  * @memberof Sgkz006dComponent
  */
  constructor() {}

  /**
  * 初期処理
  * @memberof Sgkz006dComponent
  */
  ngOnInit(): void {}

  /**
   * コンポーネント破棄処理
   * @memberof Sgkz006dComponent
   */
  ngOnDestroy(): void {}
}